<template>
    <div class="workout__item noselect" @click="handlePlaylistClick(playlist)">

        <!-- Premium Badge -->
        <div v-if="showPremiumBadge" class="workout__item__premium">
            <img src="@/assets/ic_20_premium.svg" alt="">
        </div>

        <!-- Image -->
        <img max-width="100%" 
        :src="'https://app.sportlerplus.com/scaled/800/' + playlist.image_url" class="workout__item__image">

        <div class="workout__item__meta">
            <!-- Equipment -->
            <div v-if="playlist.requires_equipment" class="workout__item__meta__icon">
                <img src="@/assets/ic_32_workout_item_equipment.svg" alt="" />
            </div>

            <!-- Intensität -->
            <div class="workout__item__meta__icon">
                <img v-if="playlist.difficulty == 3" src="@/assets/ic_32_workout_item_intensity-high.svg" alt="" />
                <img v-else-if="playlist.difficulty == 1" src="@/assets/ic_32_workout_item_intensity-low.svg" alt="" />
                <img v-else-if="playlist.difficulty == 2" src="@/assets/ic_32_workout_item_intensity-medium.svg" alt="" />
            </div>

            <!-- Dauer -->
            <div class="workout__item__meta__icon">
                <span>{{ playlist.duration }}'</span>
                <img src="@/assets/ic_32_workout_item_time.svg" alt="" />
            </div>
        </div>

        <!-- Title -->
        <h3 class="workout__item__title">
            <!--<div class="workout__item__badge">{{ workout.badge }}</div>-->
            {{ playlist.title }}
        </h3>
    </div>
</template>
<script>
export default {
    name: 'PlaylistItem',
    props: {
        playlist: {
            type: Object,
            default() { return {}; } 
        },
        selectOnly: {
            type: Boolean,
        }
    },
    computed: {
        premiumStatus() {
            return this.$store.getters.getPremiumStatus;
        },
        showPremiumBadge() {
            return (this.playlist.premium_content && Object.keys(this.premiumStatus).length === 0);
        }
    },
    methods: {
        handlePlaylistClick(playlist) {
            if (this.selectOnly) {
                this.$emit("selectPlaylist", playlist);
                return;
            }

            if (playlist.premium_content && Object.keys(this.premiumStatus).length === 0) {
                this.$emit('showPremiumHint');
            }
            else {
                this.$router.push("/playlist/start?playlist_id=" + playlist.id);
            }
        }
    }
}
</script>
<style scoped>
a {
    text-decoration: none;
}
</style>